import Luiv3Constants, {LuiV3ColorKey} from '@app/lui3/constants';
import styled from 'styled-components';

import BtnContainer from '../BtnContainer';
import AbsLayer from './AbsLayer';

interface Props {
  backgroundColor: LuiV3ColorKey;
  outlineColor: LuiV3ColorKey;
  hoverOutlineColor: LuiV3ColorKey;
  hoverColor: LuiV3ColorKey;
}

const OutlineBaseLayer = styled(AbsLayer)<Props>`
  --hover-bg-color: ${({hoverColor}) => Luiv3Constants.baseColor[hoverColor]};
  --hover-outline-color: ${({hoverOutlineColor}) =>
    Luiv3Constants.baseColor[hoverOutlineColor]};

  border: solid var(--theme-button-border-thickness)
    ${({outlineColor}) => Luiv3Constants.baseColor[outlineColor]} !important;
  background-color: ${({backgroundColor}) =>
    Luiv3Constants.baseColor[backgroundColor]};

  ${BtnContainer}:hover & {
    background-color: var(--hover-bg-color);
    border-color: var(--hover-outline-color) !important;
  }
`;

export default OutlineBaseLayer;
